import {Form, Formik} from 'formik';
import SubmitButton from "../components/formik/SubmitButton";
import axios from "../services/axios";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {loginUser} from "../redux/reducer/authSlice";
import {handleErrors} from "../helpers/handleErrors";
import {LoginSchema} from "../validations/LoginSchema";
import Box from "../components/base/Box";
import TextField from "../components/formik/TextField";

function Login() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const login = (values, actions) => {
        axios.post("/auth/token", values)
            .then((response) => {
                dispatch(loginUser(response.data));
                actions.setSubmitting(false);
                navigate("/");
            })
            .catch((error) => {
                actions.setErrors(handleErrors(error))
                actions.setSubmitting(false);
            })
    }

    return (
        <>
            <div className="login">
                <div className="login__card">
                    <div className="login__logo">
                        <img src="/main-logo.jpeg" alt="بنک بازار"/>
                    </div>

                    <Formik
                        initialValues={{
                            phone: '',
                            password: '',
                        }}
                        validationSchema={LoginSchema}
                        onSubmit={(values, actions) => login(values, actions)}>
                        {({isSubmitting}) => {
                            return (
                                <Form>
                                    <Box boxContentClassName="pb0" footer={<SubmitButton text="ورود" isSubmitting={isSubmitting}/>}>
                                        <TextField type="text" label="موبایل" name="phone" className="english-number"/>
                                        <TextField type="password" label="رمز عبور" name="password" className="english-number"/>
                                    </Box>
                                </Form>
                            )
                        }}
                    </Formik>
                </div>
            </div>
        </>
    )
}

export default Login;
